import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { OfferTeam } from './type';

const getOfferTeams = async (offerId: string): Promise<OfferTeam[]> => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offers/${offerId}/offer-teams`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetOfferTeams = ({ offerId = '', enabled }: { offerId?: string; enabled: boolean }) => {
  return useGenericQuery<OfferTeam[], RequestError>([QUERY_KEYS.getOfferTeams, offerId], () => getOfferTeams(offerId), {
    enabled,
  });
};
